import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from "react-datepicker";
import { Delete, Visibility, Download, Store, Add } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  console.log("Here is the props", props.id);
  let vendorType = "";
  const [formData, setFormData] = useState({
    vendorName: "",
    vendorQty: "",
    vendorDate: new Date(),
  });
  const [currentItem, setCurrentItem] = useState("");
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [itemList, setItemList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [showExtendModal, setShowExtendModal] = useState(false);

  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    // {
    //   name: "Sr.No",
    //   selector: (row, index) => (page - 1) * countPerPage + index + 1,
    //   sortable: false,
    //   maxWidth: "80px", // Adjust the maximum width as needed
    //   minWidth: "60px",
    // },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Address",
      selector: (row) => (
        <>
          {row.address}
          <br />
          {row.state}
          <br />
          {row.district}
          <br />
          {row.city}
          <br />
          {row.pincode}
        </>
      ),
    },
    {
      name: "Contact Name",
      selector: (row) => (
        <>
          {row.contact_person_name}
          <br />

          {row.contact_person_phone}
        </>
      ),
    },

    ...(utils.hasPermission(
      primaryMenuRes,
      "Destination Center",
      "destination_center.edit"
    ) ||
    utils.hasPermission(
      primaryMenuRes,
      "Destination Center",
      "destination_center.delete"
    )
      ? [
          {
            name: "Action",
            center: true,
            cell: (row) => (
              <>
                {utils.hasPermission(
                  primaryMenuRes,
                  "Destination Center",
                  "destination_center.edit"
                ) && (
                  <RB.Button
                    className="btn-circle"
                    variant="outline-primary"
                    size="sm"
                    onClick={handelEdit(row)} // Ensure to wrap this in a function call
                  >
                    <EditIcon />
                  </RB.Button>
                )}
                &nbsp;
                {utils.hasPermission(
                  primaryMenuRes,
                  "Destination Center",
                  "destination_center.delete"
                ) && (
                  <RB.Button
                    className="btn-circle"
                    variant="outline-danger"
                    size="sm"
                    onClick={showDelete(row)} // Wrap the function call properly
                  >
                    <Delete />
                  </RB.Button>
                )}
              </>
            ),
          },
        ]
      : []),
  ];

  const resetFormData = () => {
    setFormData({
      vendorName: "",
      vendorQty: "",
      vendorDate: "",
    });
  };

  const handleAdd = (row) => {
    setCurrentItem(row);
    setShowExtendModal(true);
  };

  useEffect(() => {
    getLocationList();
  }, [page, userProfile?.id, vendorType]);

  const getLocationList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("get", `/sales/getLocationList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setItemList(res);
        } else {
          setItemList([]);
        }
      })
      .catch((err) => {
        setItemList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleGodown = useCallback((row) => async () => {
    const propdata = {
      mode: "godown",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getLocationDelete?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getLocationList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;
    if (name === "vendorQty") {
      validatedValue = value.replace(/\D/g, "");
    }
    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            {utils.hasPermission(
              primaryMenuRes,
              "Destination Center",
              "destination_center.create"
            ) && (
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleAddClick}
              >
                Add Location
              </RB.Button>
            )}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Destination Center",
            "destination_center.view"
          ) && (
            <DataTable
              columns={columns}
              data={itemList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={itemList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
